import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Clock, Zap, TrendingDown } from 'lucide-react';

interface SwapPreviewProps {
  tokenIn: string;
  tokenOut: string;
  amountIn: string;
  amountOut: string;
  slippage: number;
  gasEstimate: string;
}

export function SwapPreview({
  tokenIn,
  tokenOut,
  amountIn,
  amountOut,
  slippage,
  gasEstimate,
}: SwapPreviewProps) {
  const rate = parseFloat(amountOut) / parseFloat(amountIn);
  const minimumReceived = parseFloat(amountOut) * (1 - slippage / 100);
  const priceImpact = 0.12; // Mock price impact

  return (
    <Card className="bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800">
      <CardContent className="p-4 space-y-3">
        <div className="flex items-center justify-between text-sm">
          <span className="text-slate-600 dark:text-slate-400">Exchange Rate</span>
          <span className="font-medium">
            1 {tokenIn} = {rate.toFixed(4)} {tokenOut}
          </span>
        </div>

        <div className="flex items-center justify-between text-sm">
          <span className="text-slate-600 dark:text-slate-400">Minimum Received</span>
          <span className="font-medium">
            {minimumReceived.toFixed(4)} {tokenOut}
          </span>
        </div>

        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center gap-1">
            <TrendingDown className="h-3 w-3 text-slate-500" />
            <span className="text-slate-600 dark:text-slate-400">Price Impact</span>
          </div>
          <Badge variant={priceImpact < 1 ? "default" : priceImpact < 3 ? "secondary" : "destructive"}>
            {priceImpact.toFixed(2)}%
          </Badge>
        </div>

        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center gap-1">
            <Zap className="h-3 w-3 text-slate-500" />
            <span className="text-slate-600 dark:text-slate-400">Est. Gas Fee</span>
          </div>
          <span className="font-medium">
            {gasEstimate} ETH (≈ ${(parseFloat(gasEstimate) * 2845.67).toFixed(2)})
          </span>
        </div>

        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center gap-1">
            <Clock className="h-3 w-3 text-slate-500" />
            <span className="text-slate-600 dark:text-slate-400">Est. Time</span>
          </div>
          <span className="font-medium">~15 seconds</span>
        </div>

        <div className="pt-2 border-t border-blue-200 dark:border-blue-800">
          <div className="flex items-center justify-between text-xs text-slate-500 dark:text-slate-400">
            <span>Route</span>
            <span>Uniswap V3 → 1inch</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}